export default [
    {
        path: 'aih',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-aih' */
            '@/views/pronto-atendimento/aih/Index'
        ),
        redirect: 'aih/index',
        children: [
            {
                name: 'pronto-atendimento-aih-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-aih' */
                    '@/views/pronto-atendimento/aih/List.vue'),
            },
            {
                name: 'pronto-atendimento-aih-paciente',
                path: 'paciente',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-aih' */
                    '@/views/pronto-atendimento/aih/ListPaciente.vue'),
            },
            {
                name: 'pronto-atendimento-aih-create',
                path: 'create/:pacienteId?',
                props: route => ({ pacienteId: parseInt(route.params.pacienteId) }),
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-aih' */
                    '@/views/pronto-atendimento/aih/Form'
                ),
            },
            {
                name: 'pronto-atendimento-aih-edit',
                path: 'edit/:id?',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-aih' */
                    '@/views/pronto-atendimento/aih/Form'
                ),
            },
        ]
    }
]